<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M38.605 36.7992H1.45841C1.12147 36.7992 0.82666 37.094 0.82666 37.4309V39.3683C0.82666 39.7052 1.12147 40 1.45841 40H38.6471C38.9841 40 39.2789 39.7052 39.2789 39.3683V37.4309C39.2789 37.094 38.9841 36.7992 38.605 36.7992Z"
      fill="currentColor"
    />
    <path
      d="M21.0004 34.6512C21.3374 34.6512 21.6322 34.3564 21.6322 34.0195V21.8057C21.6322 21.4688 21.3374 21.174 21.0004 21.174H19.0631C18.7261 21.174 18.4313 21.4688 18.4313 21.8057V34.0195C18.4313 34.3564 18.7261 34.6512 19.0631 34.6512H21.0004Z"
      fill="currentColor"
    />
    <path
      d="M27.739 34.6512C28.076 34.6512 28.3708 34.3564 28.3708 34.0195V21.8057C28.3708 21.4688 28.076 21.174 27.739 21.174H25.8017C25.4647 21.174 25.1699 21.4688 25.1699 21.8057V34.0195C25.1699 34.3564 25.4647 34.6512 25.8017 34.6512H27.739Z"
      fill="currentColor"
    />
    <path
      d="M14.2618 34.6512C14.5987 34.6512 14.8935 34.3564 14.8935 34.0195V21.8057C14.8935 21.4688 14.5987 21.174 14.2618 21.174H12.3244C11.9875 21.174 11.6927 21.4688 11.6927 21.8057V34.0195C11.6927 34.3564 11.9875 34.6512 12.3244 34.6512H14.2618Z"
      fill="currentColor"
    />
    <path
      d="M7.56531 34.6512C7.90224 34.6512 8.19706 34.3564 8.19706 34.0195V21.8057C8.19706 21.4688 7.90224 21.174 7.56531 21.174H5.62796C5.29103 21.174 4.99622 21.4688 4.99622 21.8057V34.0195C4.99622 34.3564 5.29103 34.6512 5.62796 34.6512H7.56531Z"
      fill="currentColor"
    />
    <path
      d="M34.4356 34.6512C34.7725 34.6512 35.0673 34.3564 35.0673 34.0195V21.8057C35.0673 21.4688 34.7725 21.174 34.4356 21.174H32.4982C32.1613 21.174 31.8665 21.4688 31.8665 21.8057V34.0195C31.8665 34.3564 32.1613 34.6512 32.4982 34.6512H34.4356Z"
      fill="currentColor"
    />
    <path
      d="M39.0262 16.2885L21.0846 0.410634C20.495 -0.136878 19.5685 -0.136878 18.9788 0.410634L1.03726 16.2885C0.531865 16.7097 0.363399 17.4256 0.616097 18.0574C0.868795 18.6891 1.45842 19.0682 2.09017 19.0682H37.9312C38.605 19.0682 39.1947 18.647 39.4053 18.0574C39.658 17.4256 39.4895 16.7097 39.0262 16.2885ZM20.0317 13.8879C18.3892 13.8879 17.0415 12.5401 17.0415 10.8976C17.0415 9.25507 18.3892 7.90734 20.0317 7.90734C21.6743 7.90734 23.022 9.25507 23.022 10.8976C23.022 12.5401 21.6743 13.8879 20.0317 13.8879Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "CategoryDestinationMuseum"
};
</script>
